// Ray-casting point-in-polygon. Accepts GeoJSON Polygon geometry
// ({ type: "Polygon", coordinates: [[[lng,lat], ...]] }) and a { lat, lng } point.
export const isInsidePolygon = (point, polygon) => {
  if (!point || !polygon) return false;
  const ring = polygon?.coordinates?.[0];
  if (!Array.isArray(ring) || ring.length < 3) return false;

  const { lat, lng } = point;
  let inside = false;
  for (let i = 0, j = ring.length - 1; i < ring.length; j = i++) {
    const [xi, yi] = ring[i]; // [lng, lat]
    const [xj, yj] = ring[j];
    const intersect =
      ((yi > lat) !== (yj > lat)) &&
      lng < ((xj - xi) * (lat - yi)) / (yj - yi + 1e-12) + xi;
    if (intersect) inside = !inside;
  }
  return inside;
};

// Convert a leaflet-draw polygon layer to GeoJSON ring [[lng,lat], ...],
// ensuring it is closed (first === last).
export const leafletLayerToGeoJson = (layer) => {
  const latlngs = layer.getLatLngs()[0];
  const ring = latlngs.map((ll) => [ll.lng, ll.lat]);
  if (ring.length > 0) {
    const [fx, fy] = ring[0];
    const [lx, ly] = ring[ring.length - 1];
    if (fx !== lx || fy !== ly) ring.push([fx, fy]);
  }
  return { type: "Polygon", coordinates: [ring] };
};

// Compute a rough bounding box [[southLat, westLng], [northLat, eastLng]]
// for fitBounds on a GeoJSON polygon.
export const polygonBounds = (polygon) => {
  const ring = polygon?.coordinates?.[0];
  if (!Array.isArray(ring) || ring.length === 0) return null;
  let minLat = Infinity,
    minLng = Infinity,
    maxLat = -Infinity,
    maxLng = -Infinity;
  for (const [lng, lat] of ring) {
    if (lat < minLat) minLat = lat;
    if (lat > maxLat) maxLat = lat;
    if (lng < minLng) minLng = lng;
    if (lng > maxLng) maxLng = lng;
  }
  return [
    [minLat, minLng],
    [maxLat, maxLng],
  ];
};
